import { render, staticRenderFns } from "./Listother.vue?vue&type=template&id=6c788ad2&scoped=true&"
import script from "./Listother.vue?vue&type=script&lang=js&"
export * from "./Listother.vue?vue&type=script&lang=js&"
import style0 from "./Listother.vue?vue&type=style&index=0&id=6c788ad2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c788ad2",
  null
  
)

export default component.exports
import {QLayout,QHeader,QPageContainer,QPage} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QLayout,QHeader,QPageContainer,QPage})
